var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMastercard = function SvgMastercard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 42"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-main-text)",
    fillRule: "evenodd",
    d: "M0 3a3 3 0 0 1 3-3h58a3 3 0 0 1 3 3v36a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5F00",
    d: "M37.291 12.353h-9.914v17.295h9.914z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EB001B",
    d: "M28.006 21c0-3.514 1.7-6.63 4.312-8.647A11.48 11.48 0 0 0 25.33 10C19.067 10 14 14.92 14 21s5.067 11 11.33 11c2.644 0 5.068-.886 6.988-2.353-2.613-1.986-4.312-5.133-4.312-8.647"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F79E1B",
    d: "M50.667 21c0 6.08-5.067 11-11.33 11-2.644 0-5.068-.886-6.987-2.353 2.643-2.016 4.311-5.133 4.311-8.647s-1.7-6.63-4.311-8.647A11.48 11.48 0 0 1 39.337 10c6.263 0 11.33 4.95 11.33 11"
  })));
};
export default SvgMastercard;